export default __webpack_public_path__ + "static/media/about image.284e3f6e.svg";